module.exports = __webpack_public_path__ + "static/image/logo-family/logo_one@2x.png?788a87d0";